"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaceRecognitionTriggerReason = void 0;
var FaceRecognitionTriggerReason;
(function (FaceRecognitionTriggerReason) {
    FaceRecognitionTriggerReason[FaceRecognitionTriggerReason["None"] = 0] = "None";
    FaceRecognitionTriggerReason[FaceRecognitionTriggerReason["ResetPassword"] = 2] = "ResetPassword";
    FaceRecognitionTriggerReason[FaceRecognitionTriggerReason["UpdatePersonalInformation"] = 4] = "UpdatePersonalInformation";
    FaceRecognitionTriggerReason[FaceRecognitionTriggerReason["FailedLoginUnlock"] = 8] = "FailedLoginUnlock";
    FaceRecognitionTriggerReason[FaceRecognitionTriggerReason["Inactivity"] = 16] = "Inactivity";
    FaceRecognitionTriggerReason[FaceRecognitionTriggerReason["Weekly"] = 32] = "Weekly";
    FaceRecognitionTriggerReason[FaceRecognitionTriggerReason["Registration"] = 64] = "Registration";
    FaceRecognitionTriggerReason[FaceRecognitionTriggerReason["All"] = 126] = "All";
})(FaceRecognitionTriggerReason = exports.FaceRecognitionTriggerReason || (exports.FaceRecognitionTriggerReason = {}));
